<template>
  <Admin>
    <v-main>
      <div class="tw-container tw-mx-auto tw-p-6">
        <div class="tw-mb-6">
          <h1 class="tw-text-2xl tw-font-bold tw-text-gray-800">PND 50-55</h1>
          <p class="tw-text-gray-600 tw-mt-2">ภาษีเงินได้หัก ณ ที่จ่าย (พ.ร.ด. ภาษีเงินได้) แบบ ภ.ง.ด.50-55</p>
        </div>

        <div class="tw-bg-white tw-rounded-lg tw-shadow tw-p-8">
          <div class="tw-flex tw-items-center tw-justify-center tw-flex-col tw-py-12">
            <img src="/images/icons/icon_menu_ap.svg" class="tw-w-24 tw-h-24 tw-mb-6 tw-opacity-50">
            <p class="tw-text-lg tw-text-gray-600 tw-mb-2">PND 50-55 Form Management</p>
            <p class="tw-text-sm tw-text-gray-500">Coming Soon</p>
          </div>
        </div>
      </div>
    </v-main>
  </Admin>
</template>

<script>
import Admin from '@/components/admin/admin-main-template'

export default {
  name: 'documents.revenuedepartment.pnd50to55',
  components: {
    Admin,
  }
}
</script>

<style scoped>
/* Add any custom styles here if needed */
</style>
